import { Check } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

const CheckIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Check width={size} height={size} color={color} {...rest} />;

CheckIcon.displayName = 'CheckIcon';

export default CheckIcon;
